import styled from '@emotion/styled';

import Box from '~/common/components/Box';

export const RailNavigationGroup = styled(Box)`
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  box-sizing: border-box;

  & a {
    padding: 0 10px;
    button {
      background-color: white;
      border-left: 1px solid ${(props) => props.theme.colors.gray[300]};
      border-right: 1px solid ${(props) => props.theme.colors.gray[300]};
      border-bottom: 1px solid ${(props) => props.theme.colors.gray[300]};
    }
  }

  & a:first-of-type {
    padding: 8px 10px 0;
    border-radius: 8px 8px 0 0;

    & button {
      border-top: 1px solid ${(props) => props.theme.colors.gray[300]};
      border-radius: 8px 8px 0 0;
    }
  }

  & a:last-of-type {
    padding: 0 10px 8px;
    border-radius: 0 0 8px 8px;

    & button {
      border-radius: 0 0 8px 8px;
    }
  }
`;

export const RailModalGroup = styled(Box)`
  display: flex;
  flex-direction: column;

  & div {
    padding: 8px 10px;
    cursor: pointer;
    button {
      border-radius: 8px;
    }
  }
`;

export const RailExternalGroup = styled(Box)`
  display: flex;
  flex-direction: column;
  margin-top: auto;

  & div {
    padding: 8px 10px;

    & button {
      background-color: white;
      border-radius: 8px;
      border: 1px solid ${(props) => props.theme.colors.gray[300]};

      & img {
        max-width: 28px;
        max-height: 28px;
        padding-bottom: 4px;
      }
    }
  }

  & div:not(:last-of-type) {
    padding-bottom: 0;
  }
`;

export const RailModalDivider = styled.hr<{ width?: string }>`
  width: ${(props) => props.width ?? '24px'};
  border: none;
  border-top: 1px solid ${(props) => props.theme.colors.gray[300]};
  margin: 0 auto;
`;
